import React, { Component } from "react";
import { toast } from "react-toastify";

export default class BaseComponent extends Component {
  toEnglishNumber(x) {
    var charCodeZero = "۰".charCodeAt(0);
    return parseInt(
      x.replace(/[۰-۹]/g, function (w) {
        return w.charCodeAt(0) - charCodeZero;
      })
    ).toString();
  }

  BindInput(arrayItem, itemName, element) {
    var elementType = element.type;

    var finalValue;

    switch (elementType) {
      case "text":
        finalValue = element.value;
        break;
      case "checkbox":
        finalValue = element.checked;
        break;
      case "select-one":
        finalValue = element.value;
        break;
      default:
        finalValue = element.value;
    }

    var localState = this.state;

    localState[arrayItem][itemName] = finalValue;

    this.setState(localState);
  }

  BindTimePickers() {
    var base = this;
    $(".timepicker-component").each(function () {
      var $this = $(this);
      var model = $this.attr("data-model");
      var title = $this.attr("data-title"),
        initTime = $this.data("time");

      var timePicker = $this.pDatepicker({
        format: "HH:mm",
        initialValue: false,
        onlyTimePicker: true,
        observe: true,
        timePicker: {
          enabled: true,
          second: {
            enabled: false,
          },
          meridiem: {
            enabled: false,
          },
        },
      });

      let unix = 0;
      if (initTime !== "") {
        let splitTime = initTime
          .split(":")
          .map((item) => +base.toEnglishNumber(item));

        let time = new persianDate(splitTime)
          .hour(splitTime[0])
          .minute(splitTime[1]).ON.gDate;

        let unix = Math.floor(time);

        timePicker.setDate(time);
      }
    });
  }

  BindDateTimePickers() {
    var base = this;
    $(".datetimepicker-component input").each(function () {
      var $this = $(this);
      var model = $this.attr("data-model");
      var title = $this.attr("data-title"),
        initDate = $this.data("date");

      $this.attr("readonly", "readonly");
      var datePicker = $this.persianDatepicker({
        inline: true,
        format: "YYYY/MM/DD HH:mm",
        initialValue: false,
        responsive: false,
        navigator: {
          enabled: true,
          scroll: {
            enabled: true,
          },
        },
        timePicker: {
          enabled: true,
          meridiem: {
            enabled: false,
          },
        },
        toolbox: {
          enabled: false,
        },

        onSelect: function (e) {
          var localState = base.state;

          localState[model][title] = new persianDate(e).format(
            "YYYY/MM/DD HH:mm"
          );

          base.setState(localState);
        },
      });

      let unix = 0;
      let date = "";
      if (initDate !== "") {
        let datePart = initDate
          .split(" ")[0]
          .split("/")
          .map((item) => +base.toEnglishNumber(item));
        let timePart = initDate
          .split(" ")[1]
          .split(":")
          .map((item) => +base.toEnglishNumber(item));

        let dateTimePart = datePart.concat(timePart);

        date = new persianDate(dateTimePart).toCalendar("gregorian").ON.gDate;
        unix = Math.floor(date);
        datePicker.setDate(unix);
      }
    });
  }

  BindDatePickers() {
    var base = this;
    $(".datetimepicker-component input").each(function () {
      console.log('fsdfsdfsd')
      var $this = $(this);
      var model = $this.attr("data-model");
      var title = $this.attr("data-title"),
        initDate = $this.data("date");

      $this.attr("readonly", "readonly");
      var datePicker = $this.pDatepicker({
        format: "YYYY/MM/DD",
        initialValue: false,
        responsive: false,
        timePicker: {
          enabled: false,
        },
        toolbox: {
          enabled: false,
        },

        onSelect: function (e) {
          var localState = base.state;

          localState[model][title] = new persianDate(e).format("YYYY/MM/DD");

          base.setState(localState);
        },
      });

      let unix = 0;
      let date = "";
      if (initDate !== "") {
        let datePart = initDate
          .split(" ")[0]
          .split("/")
          .map((item) => +base.toEnglishNumber(item));

        date = new persianDate(datePart).toCalendar("gregorian").ON.gDate;
        unix = Math.floor(date);
        datePicker.setDate(unix);
      }
    });
  }
  BindToast(text, type) {
    switch (type) {
      case 'error':
        return toast.error(text, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        });
        case 'success':
          return toast.success(text, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
          });
    }
  }
}



// WEBPACK FOOTER //
// ./src/Components/BaseComponent.jsx